import type { RuleHandler } from "../types";

const checkMinimumOutcomes: RuleHandler = (context, requirement) => {
  const minOutcomes = requirement.userDrivenAttributes?.minimumOutcomes ?? 0;

  return minOutcomes <= context.selection.subOutcomesCount;
};

export { checkMinimumOutcomes };
